
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ENV_BASE =
  (typeof import.meta !== 'undefined'
    ? import.meta.env?.VITE_FN_BASE
    : process.env?.REACT_APP_FN_BASE) || '';
const FN_BASE = String(ENV_BASE || '').replace(/\/$/, '');
const AUTH_BASE = FN_BASE || '/auth';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const { refreshMe } = useAuth();

  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');


  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const t = params.get('token') || '';
      const e = params.get('email') || '';

      setToken(t);
      setEmail(e);
    } catch {

      setToken('');
      setEmail('');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    const p = String(password || '').trim();
    const c = String(confirm || '').trim();
    const em = String(email || '').trim();
    const tk = String(token || '').trim();

    if (!tk || !em) {
      setErrorMsg('الرابط غير صالح. حاول طلب رابط جديد من صفحة نسيت كلمة المرور.');
      return;
    }

    if (!p || !c) {
      setErrorMsg('يرجى إدخال كلمة المرور وتأكيدها.');
      return;
    }

    if (p.length < 8) {
      setErrorMsg('كلمة المرور يجب ألا تقل عن 8 أحرف.');
      return;
    }

    if (p !== c) {
      setErrorMsg('كلمتا المرور غير متطابقتين.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${AUTH_BASE}/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: em,
          token: tk,
          password: p
        })
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const msg =
          data?.message ||
          data?.error === 'invalid_or_expired'
            ? 'الرابط غير صالح أو منتهي. يرجى طلب رابط جديد.'
            : 'تعذر تحديث كلمة المرور. حاول مرة أخرى.';
        setErrorMsg(msg);
        return;
      }

      setSuccessMsg('تم تحديث كلمة المرور بنجاح. سيتم تحويلك للصفحة الرئيسية.');
      setPassword('');
      setConfirm('');


      try {
        await refreshMe?.();
      } catch {

      }

      setTimeout(() => {
        navigate('/', { replace: true });
      }, 2500);
    } catch {
      setErrorMsg('تعذر الاتصال بالخادم. حاول مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  const isInvalidLink = !token || !email;

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#020817] text-white px-4">
      <div
        className="w-full max-w-md rounded-2xl border border-slate-800 shadow-xl"
        style={{
          background:
            'linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), radial-gradient(92.12% 184.55% at 50% -55%, rgba(40, 227, 218, 0.2) 0%, rgba(40, 227, 218, 0) 100%), #081423',
          padding: '32px 24px'
        }}
      >
        <h1
          className="text-2xl font-semibold mb-2 text-center"
          style={{ fontFamily: 'Alexandria' }}
        >
          إعادة تعيين كلمة المرور
        </h1>

        <p
          className="text-sm text-slate-300 mb-6 text-center"
          style={{ fontFamily: 'Alexandria' }}
        >
          {isInvalidLink
            ? 'الرابط غير صالح. يرجى العودة وطلب رابط جديد من صفحة "نسيت كلمة المرور".'
            : 'قم بتعيين كلمة مرور جديدة لحسابك.'}
        </p>

        {errorMsg && (
          <div
            className="mb-4 px-4 py-2 rounded-lg text-sm text-red-400"
            style={{
              fontFamily: 'Alexandria',
              background: 'rgba(239, 68, 68, 0.1)',
              border: '1px solid rgba(239, 68, 68, 0.3)'
            }}
          >
            {errorMsg}
          </div>
        )}

        {successMsg && (
          <div
            className="mb-4 px-4 py-2 rounded-lg text-sm text-green-400"
            style={{
              fontFamily: 'Alexandria',
              background: 'rgba(34, 197, 94, 0.1)',
              border: '1px solid rgba(34, 197, 94, 0.3)'
            }}
          >
            {successMsg}
          </div>
        )}

        {!isInvalidLink && (
          <form onSubmit={handleSubmit} className="space-y-4" dir="rtl">
            <div className="text-right">
              <label
                className="block mb-1 text-sm text-slate-200"
                style={{ fontFamily: 'Alexandria' }}
              >
                كلمة المرور الجديدة
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-xl bg-[rgba(255,255,255,0.05)] border border-[rgba(40,227,218,0.25)] px-3 py-2 text-right text-white placeholder-slate-400 focus:outline-none"
                style={{ fontFamily: 'Alexandria', fontSize: '14px' }}
                placeholder="أدخل كلمة مرور قوية"
              />
            </div>

            <div className="text-right">
              <label
                className="block mb-1 text-sm text-slate-200"
                style={{ fontFamily: 'Alexandria' }}
              >
                تأكيد كلمة المرور
              </label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="w-full rounded-xl bg-[rgba(255,255,255,0.05)] border border-[rgba(40,227,218,0.25)] px-3 py-2 text-right text-white placeholder-slate-400 focus:outline-none"
                style={{ fontFamily: 'Alexandria', fontSize: '14px' }}
                placeholder="أعد كتابة كلمة المرور"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full mt-2 rounded-xl py-2 text-center disabled:opacity-60"
              style={{
                fontFamily: 'Alexandria',
                fontSize: '16px',
                background:
                  'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(40, 227, 218, 0.25)',
                border: '0.9px solid rgba(40, 227, 218, 0.25)'
              }}
            >
              {loading ? 'جارٍ الحفظ...' : 'تحديث كلمة المرور'}
            </button>
          </form>
        )}

        <div className="mt-6 flex justify-center">
          <button
            type="button"
            onClick={() => navigate('/', { replace: true })}
            className="text-sm underline"
            style={{ fontFamily: 'Alexandria' }}
          >
            العودة للصفحة الرئيسية
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
